<style>
	.bottom {
		flex: none;
		background-color: white;
		border-top-left-radius: 1rem;
		border-top-right-radius: 1rem;
		box-shadow: 0 -4px 8px 2px rgba(0,0,0,0.17);
		margin-left: 1.5rem;
		margin-right: 1.5rem;
  }

	.padded {
		padding: 1.5rem;
	}
</style>
<script>
  export let padded = true;
</script>

<div class="bottom" class:padded={padded}>
	<slot></slot>
</div>
